/* eslint-disable max-len */
import React from 'react';

const Journal: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6575_138734)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.47168 0C2.79509 1.41368e-08 3.0916 0.182475 3.23633 0.47168C3.55109 1.10119 4.44891 1.10119 4.76367 0.47168C4.9084 0.182475 5.20491 -1.41368e-08 5.52832 0H6.5C6.80643 1.33946e-08 7.08659 0.173184 7.22363 0.447266L7.23633 0.47168C7.55109 1.10119 8.44891 1.10119 8.76367 0.47168L8.77637 0.447266C8.91341 0.173184 9.19357 -1.33946e-08 9.5 0H10C11.1046 6.43889e-08 12 0.895431 12 2V9C12 10.6569 10.6569 12 9 12H3C1.34315 12 -7.24234e-08 10.6569 0 9V1.85449C4.47601e-08 0.8305 0.8305 -4.47601e-08 1.85449 0H2.47168ZM2.5 8.5C2.22386 8.5 2 8.72386 2 9C2 9.27614 2.22386 9.5 2.5 9.5H9.5L9.60059 9.49023C9.82855 9.44371 10 9.24171 10 9C10 8.75829 9.82855 8.55629 9.60059 8.50977L9.5 8.5H2.5ZM2.5 6.5C2.22386 6.5 2 6.72386 2 7C2 7.27614 2.22386 7.5 2.5 7.5H9.5L9.60059 7.49023C9.82855 7.44371 10 7.24171 10 7C10 6.75829 9.82855 6.55629 9.60059 6.50977L9.5 6.5H2.5ZM2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H5.5C5.77614 5 6 4.77614 6 4.5C6 4.22386 5.77614 4 5.5 4H2.5Z"
                    fill="#616E6E"
                />
            </g>
            <defs>
                <clipPath id="clip0_6575_138734">
                    <rect
                        width="12"
                        height="12"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Journal;